import { Link } from "@tanstack/react-router";
import { SafeExternalLink } from "@/components/SafeExternalLink";
import { OutboundArrow } from "@/components/OutboundArrow";
import stoetMotif from "@/assets/motifs/levekunst.png";

const TENER_URL = "https://10er.com/flaneriet";

/**
 * Blød støttenote i bunden af forsiden.
 * Ærlig om omkostningerne – ingen hård CTA, ingen løfter om fordele.
 */
export function SupportNote() {
  return (
    <section className="rule-double py-12 md:py-16" aria-label="Støt Flâneriet">
      <div className="max-w-2xl mx-auto text-center">
        <img
          src={stoetMotif}
          alt=""
          aria-hidden="true"
          width={512}
          height={512}
          loading="lazy"
          className="mx-auto mb-5 w-[72px] md:w-[88px] h-auto opacity-80"
        />
        <p className="eyebrow mb-4">Støt Flâneriet</p>

        <h2 className="font-serif text-[26px] md:text-[32px] leading-[1.12] text-ink m-0 mb-5">
          Kan du lide roen?
        </h2>

        <div className="font-serif font-light text-[15.5px] md:text-[17px] leading-[1.75] text-ink-body space-y-4">
          <p>
            Flâneriet er gratis og forbliver det. Der er ingen betalingsmur, ingen
            fordele for dem, der støtter, og ingen reklamer for dem, der ikke gør.
          </p>
          <p>
            Alligevel koster det noget at holde i gang: AI-tokens til at vurdere og
            bearbejde tekster, Firecrawl til at hente artikler ind, domæne og hosting –
            og så timerne med at læse, vurdere og finjustere, så samlingen holder
            niveauet.
          </p>
          <p className="italic text-ink-soft">
            Hvis du har lyst til at hjælpe med at holde stedet åbent og langsomt, er en
            kop kaffe en fin måde at gøre det på. Ingen binding – du støtter på den
            måde, der passer dig bedst.
          </p>
        </div>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Link
            to="/stoet"
            className="btn-base inline-flex"
          >
            Læs mere om støtten →
          </Link>

          <SafeExternalLink
            href={TENER_URL}
            className="inline-flex items-center gap-1.5 font-serif italic text-[15px] text-accent hover:text-accent-dark transition-colors"
          >
            <span>Gi' en kop kaffe på 10er</span>
            <OutboundArrow />
          </SafeExternalLink>
        </div>
      </div>
    </section>
  );
}
